var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mb-3 col-sm-12 col-md-6 col-lg-6 p-0" }, [
    _c("div", { staticClass: "input-group" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchTerm,
            expression: "searchTerm"
          }
        ],
        staticClass: "form-control search-input",
        attrs: {
          type: "search",
          placeholder: "Filter these " + _vm.totalCount + " results by keyword"
        },
        domProps: { value: _vm.searchTerm },
        on: {
          input: [
            function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchTerm = $event.target.value
            },
            _vm.onSearchInput
          ],
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.onEnter($event)
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "input-group-append" }, [
        _c(
          "button",
          {
            staticClass: "btn text-size-normal btn btn-light",
            attrs: { tabindex: "-1", type: "submit" },
            on: { click: _vm.onEnter }
          },
          [
            _c("span", {
              staticClass: "png-icon png-icon-icons-glyph--k-search"
            })
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _vm.suggestions.length > 0 && _vm.searchTerm && _vm.showSuggestion
      ? _c(
          "div",
          { staticClass: "search-suggestion w-100" },
          _vm._l(_vm.suggestions, function(item) {
            return _c("div", { key: item }, [
              _c(
                "p",
                {
                  staticClass: "font-24 px-2 py-1 mb-0",
                  attrs: { id: item },
                  on: {
                    click: function($event) {
                      return _vm.suggestionUpdate(item)
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(item) + "\n      ")]
              )
            ])
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }